package com.tixforgigs.common.core.enums

import com.tixforgigs.tarami.GlobalMessage.buttonLogin
import com.tixforgigs.tarami.GlobalMessage.buttonSignUp
import com.tixforgigs.tarami.GlobalMessage.titleLogin
import com.tixforgigs.tarami.GlobalMessage.titleSignUp

enum class LoginMode(val index: Int, val title: String, val button: String) {
  LOGIN(0, titleLogin(), buttonLogin()),
  SIGNUP(1, titleSignUp(), buttonSignUp())
}
